import { differenceInMinutes } from 'date-fns';

const warningThresholdInMinutes = 15;

export const shouldWarnAboutStart = (scheduledOn: string) => {
    return (
        differenceInMinutes(scheduledOn, new Date()) > warningThresholdInMinutes
    );
};
